// extracted by mini-css-extract-plugin
module.exports = {"main":"styles_main__1e-Je","header":"styles_header__3HehF","content":"styles_content__1_3Rd","form":"styles_form__3BeLq","reject":"styles_reject__1g6lx"};